import React, { Component } from "react";

class Search extends Component {
  state = { name: "" };
  handleChange = (e) => {
    let { currentTarget: input } = e;
    let { name } = this.state;
    name = input.value;
    console.log(name);
    this.setState({ name });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    let { name } = this.state;
    console.log(name);
    this.props.onSubmit(name);
  };
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          className="form-control"
          type="search"
          value={this.state.name}
          name="name"
          onChange={this.handleChange}
          placeholder="&#xf002; Search for movies"
          style={{ fontFamily: "Arial,FontAwesome" }}
        />
      </form>
    );
  }
}

export default Search;
